import { ReactNode } from 'react';
import styled from 'styled-components';
import { COLORS } from '../../styles/colors';

export interface WxRadioColorProps {
  children: ReactNode;
  disabled?: boolean;
  selected: boolean;
  onSelect: () => void;
  crossed?: boolean;
  label: string;
}

const WxRadioColor = ({
  children,
  disabled = false,
  selected = false,
  crossed = false,
  onSelect,
  label,
}: WxRadioColorProps) => {
  return (
    <Wrapper
      data-type={selected ? 'selected' : disabled ? 'disabled' : 'neutral'}
      onClick={onSelect}
    >
      <div>
        {!disabled && crossed && <DisabledLine />}

        {children}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  --size: 1.25rem;
  overflow: visible;

  width: var(--size);
  height: var(--size);
  border-radius: calc(var(--size) * 2.5);
  position: relative;
  cursor: pointer;

  input {
    position: absolute;
    overflow: hidden;
  }

  img {
    width: 100%;
    height: 100%;
  }

  &[data-type='selected'] {
    outline: 1px solid ${COLORS.red};
    outline-offset: 2px;
  }

  &[data-type='disabled'] {
    cursor: default;
    pointer-events: none;
    opacity: 0.3;
  }

  margin-right: 0.625em;
`;

const DisabledLine = styled.div`
  transform: rotate(-45deg);
  transform-origin: right;
  right: 0;
  border-top: 1px solid ${COLORS.red};
  width: 141.5%;
  position: absolute;
  top: 0;
`;

export default WxRadioColor;
